module.exports = __webpack_public_path__ + "static/scale-model-of-ybor-city-museum-state-park-in-tampa-florida-c192d836f9a978b7111ea4bc17652ecf.png";